// @ts-nocheck
import Vue from "vue";
import { mapGetters } from "vuex";
import PutStackorder from "@/classes/Stack/PostStackorder";
import dateFormatter from "@/utility/dateFormatter";
import StackOrderModalHeader from "./StackOrderModalHeader.vue";
import SuffixFormattedInput from "../common/SuffixNumberFormattedInput.vue";
import DatePicker from "../common/DatePicker.vue";
import StackTypeSelector from "./StackTypeSelector.vue";
import TariffAutocomplete from "./TariffAutocomplete.vue";
import TariffList from "./TariffList.vue";
import { deleteStackOrder, updateStackOrder, } from "@/services/stackOrderService";
import { AxiosError } from "axios";
export default Vue.extend({
    props: {
        stackOrder: {},
    },
    components: {
        StackOrderModalHeader,
        DatePicker,
        SuffixFormattedInput,
        StackTypeSelector,
        TariffAutocomplete,
        TariffList,
    },
    data() {
        return {
            editableStackOrder: {},
            saving: false,
            validation: {
                required: (value) => !!value || "Cannot be empty",
            },
        };
    },
    mounted() {
        this.editableStackOrder = structuredClone(this.stackOrder);
    },
    computed: {
        ...mapGetters({
            currentUser: "getLoggedInUser",
            globalTariffCollection: "getGlobalTariffs",
        }),
        connectedTariffIds() {
            return this.editableStackOrder.tariffIds || [];
        },
        tariffs() {
            return this.globalTariffCollection.tariffs || [];
        },
        connectedTariffs() {
            const connectedTariffs = this.tariffs.filter((tariff) => this.connectedTariffIds.includes(tariff.id));
            return connectedTariffs;
        },
        selectableTariffs() {
            const selectableTariffs = this.tariffs
                .filter((tariff) => tariff.type === "Stack")
                .filter((tariff) => !this.connectedTariffIds.includes(tariff.id));
            const sortedTariffs = selectableTariffs.sort((a, b) => a.name.localeCompare(b.name));
            return sortedTariffs;
        },
    },
    methods: {
        isValid() {
            return this.$refs.form.validate();
        },
        async onSave() {
            if (!this.isValid()) {
                return;
            }
            const stackorder = PutStackorder.constructFrom(this.editableStackOrder);
            stackorder.userId = this.currentUser.userId;
            try {
                this.saving = true;
                await updateStackOrder(stackorder, this.editableStackOrder.id);
                this.$emit("update");
                this.$emit("close");
            }
            catch (error) {
                if (error instanceof AxiosError) {
                    this.$store.dispatch("ToastMessage", {
                        type: "error",
                        message: "Unable to save stack order: " + error.response &&
                            error.response.data,
                    });
                }
            }
            finally {
                this.saving = false;
            }
        },
        onCopyOrderAsNew() {
            this.$emit("copy", this.editableStackOrder);
            this.$emit("close");
        },
        async onOrderDelete() {
            try {
                await deleteStackOrder(this.editableStackOrder.id);
                this.$emit("update");
                this.$emit("close");
            }
            catch (error) {
                this.$store.dispatch("ToastMessage", {
                    type: "error",
                    message: "Unable to delete stack order: " + error.message,
                });
            }
        },
        onRemoveTariffConnection(tariffId) {
            const index = this.connectedTariffIds.findIndex((tariff) => tariff === tariffId);
            this.editableStackOrder.tariffIds.splice(index, 1);
        },
        async onTariffSelected(tariffId) {
            if (!this.editableStackOrder.tariffIds) {
                this.editableStackOrder.tariffIds = [];
            }
            this.editableStackOrder.tariffIds.push(tariffId);
        },
        onFromDateChange(date) {
            this.editableStackOrder.from =
                dateFormatter.fromDateString(date).shift.toStartOfdayUtc;
        },
        onToDateChange(date) {
            this.editableStackOrder.to =
                dateFormatter.fromDateString(date).shift.toEndOfUtcDay;
        },
        onAllicationidelityChange(fidelity) {
            this.editableStackOrder.type = fidelity;
        },
    },
});
